// extracted by mini-css-extract-plugin
export default {"mapContainer":"CommunityFootprintMap_mapContainer__vM6nx","placeholder":"CommunityFootprintMap_placeholder__wK0wj"};